var React = require('react');

function Badge (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path3761","d":"M6.5,0l1.6,1.6L9.7,0l0.8,2.1l2.1-0.9l-0.1,2.3l2.3,0l-0.9,2.1L16,6.5l-1.6,1.6L16,9.7l-2.1,0.8l0.9,2.1\n\tl-2.3-0.1l0,2.3l-2.1-0.9L9.5,16l-1.6-1.6L6.3,16l-0.8-2.1l-2.1,0.9l0.1-2.3l-2.3,0l0.9-2.1L0,9.5l1.6-1.6L0,6.3l2.1-0.8L1.3,3.4\n\tl2.3,0.1l0-2.3l2.1,0.9L6.5,0z","fill":"currentColor"}));
}

Badge.defaultProps = {"version":"1.1","id":"svg3763","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Badge;

Badge.default = Badge;
